import script from "./oncallerrorreport.vue?vue&type=script&setup=true&lang=js"
export * from "./oncallerrorreport.vue?vue&type=script&setup=true&lang=js"

import "./oncallerrorreport.vue?vue&type=style&index=0&id=1e611be5&scoped=true&lang=scss"
import "./oncallerrorreport.vue?vue&type=style&index=1&id=1e611be5&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e611be5"]])

export default __exports__